import NotFound from "@/pages/NotFound";
import { useAuth0 } from "@auth0/auth0-react";
import useCompany from "@/contexts/CompanyContext";
import type { CompanyStatus } from "@/services/api/types";

type Props = {
  component: () => React.ReactNode;
  roleRequired: string;
  roleDenied?: string;
  statusDenied?: CompanyStatus | CompanyStatus[];
};

const RoleGuard = ({ component, roleRequired, roleDenied, statusDenied }: Props) => {
  const { user } = useAuth0();
  const company = useCompany();

  const statusDeniedList = Array.isArray(statusDenied) ? statusDenied : statusDenied ? [statusDenied] : [];

  if (statusDeniedList.includes(company.companyStatus)) {
    return <NotFound />;
  } else if (
    user &&
    roleDenied &&
    user["https://customer.seccl.tech/roles"].includes(roleDenied)
  ) {
    return <NotFound />;
  } else if (
    roleRequired === "basic" ||
    (user && user["https://customer.seccl.tech/roles"].includes(roleRequired))
  ) {
    return <>{component()}</>;
  } else {
    return <NotFound />;
  }
};

export default RoleGuard;
